<template>
 <!-- :class="{ pasifCard: !disable }" -->

<div  :disabled="disable"  :class="{ pasifCard: disable }">
     <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>
      <p class="ma-0">
            <strong style="color: black;" v-html="label"> </strong> <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
         </p> 
    <v-text-field  @keypress="sayiFilter"  v-model.number="value" :rules="listRules"  persistent-hint :hint="hint"  :placeholder="placeholder" type="number" :prefix="prefix" :suffix="suffix">
          <!-- <template v-slot:label>
              <p> 
                    <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label"> </strong>  
                  </p>
        </template> -->
           <template v-slot:append-outer>
    <slot name="edit"></slot>
   </template>
    </v-text-field>
</div>

<!-- <v-card :disabled="disable"  :class="{ pasifCard: disable }"
  elevation="3"
> 
 <v-card-text >

</v-card-text>
</v-card> -->


</template>
<script>
import { numberSF } from '@/plugins/FieldDataFormat.js'
import { rules } from '@/plugins/custom.js'
export default {
  data() {
    return {
      value:null,
        title:"",
      label: "",
      required: false,
      counter: 20,
      color: null,
      disable: false,
      hint: "",
      prefix: "",
      suffix: "",
      rules: [],
      placeholder:"Yanıtınız"
    
    }
  },
  props: {
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return numberSF;
      },
      type: Object
    },


  },
  methods: {
    dataBind(json) {
      //console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.title = json.title;
      this.description = json.description;
      this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.placeholder=json.placeholder;
      this.prefix=json.prefix;
      this.suffix=json.suffix;
      this.required=json.required;
      this.value=json.value;
      this.disable=json.disable;
    },
  sayiFilter(e) {
    const key = e.key;
    const currentValue = e.target.value;
    if (key === '.' || key === ',' ) {
      // Eğer zaten '-' varsa veya imleç başta değilse engelle
      if (currentValue.includes('.') || e.target.selectionStart !== 0) {
            return;
        
      }
            if (currentValue.includes(',') || e.target.selectionStart !== 0) {
            return;
        
      }
  e.preventDefault();
    }


    if (key === '-') {
      // Eğer zaten '-' varsa veya imleç başta değilse engelle
      if (currentValue.includes('-') || e.target.selectionStart !== 0) {
        e.preventDefault();
        
      }
      return;
    }
    // Rakamlara izin ver
    if (/[\d]/.test(key)) return;

    //Eğer '-' giriliyorsa:


   // Diğer tüm karakterleri engelle
   e.preventDefault();
  }
  },
  computed: {
   
      listRules() {
return this.rules.map(m=>rules[m]);
    
        },
    getAyar: function () {
     
      return this.ayar;
    }
  },
  created() {
    this.dataBind(this.ayar);
  },
  watch: {
       ayar: {
            immediate: true,
            handler(newVal, oldVal) {
// console.log("handler:",newVal);
// if  (newVal.required){
// newVal.rules.push(value => !!value || 'Bu alana boş bırakılamaz.')
// }

              this.dataBind(newVal);
                //this.slots.forEach(slot => {
                //    if (slot.availability > 10) slot.availability = 10;
                //});
            },
            deep: true
        },
         value(n, old) {
      this.$emit('input', n);
    }

  }
}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>